<template>
  <!-- When on mobile wrap in dialog -->
  <slotted-dialog v-if="isPhoneBool" :title="title" :externaltrigger="dialogtrigger"
    :externalCloseTrigger="dialogclosetrigger">

    <template v-slot:content>
      <slot name="content"></slot>
    </template>

    <template v-slot:buttons>
      <slot name="buttons" />
    </template>
  </slotted-dialog>


  <!-- When on anything else show normal -->
  <v-container v-else fluid class="pa-0 relative" :style="styleoverride">
    <v-progress-linear v-if="loading" indeterminate absolute style="z-index: 11;" height="2">
    </v-progress-linear>

    <slot name="header"></slot>

    <slot name="content"></slot>

    <slot name="actions"></slot>

  </v-container>
</template>


<script>
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";

export default {
  name: "SecondaryPane",
  props: {
    title: String,
    loading: Boolean,
    styleoverride: String,
  },
  components: {
    SlottedDialog
  },

  data() {
    return {
    };
  },

  methods: {

  },

  computed: {
    dialogtrigger() {
      return this.$store.state.triggerevents.previewTrigger;
    },

    dialogclosetrigger() {
      return this.$store.state.triggerevents.previewCloseTrigger;
    },
  },

  watch: {},
};
</script>


<style scoped>
.relative {
  position: relative;
}

.minitoolbar {
  position: sticky;
  top: 0px;
  z-index: 10;
  box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}

/*
.minitoolbar:after {
  content: "";
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 1) 0%,
    rgba(200, 200, 200, 1) 50%,
    rgba(255, 255, 255, 1) 100%
  );
  display: block;
  height: 2px;
  bottom: 0;
}*/
</style>